export class AppSettings {
    public static TOKEN_KEY = 'getm-auth-token'
    public static OVERLAY = 'getm-overlay'
    public static LOGIN = 'getm-overlay'
    public static COMPRAS = 'getm-compras'
    public static PRODUCTOS = 'getm-productos'
    public static DEVICE_ID = 'DEVICE_ID';
    public static JWT_L = 'JWT-L';
    public static PERFIL_USUARIO = 'PerfilUsuario';
    public static PEDIDO_ANALYTICS = 'pedido_analytics';
}
